export default function Services() {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-3">OUR EXPERTISE</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">Comprehensive Flooring Solutions</h2>
          <p className="text-3xl font-bold text-[#2E5C8A]">FOR EVERY SECTOR</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="relative group overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <div className="aspect-[4/5]">
              <img 
                src="https://public.readdy.ai/ai/img_res/f39fadbe627d43e6ee053fc2fcc9df99.jpg" 
                alt="Corporate & Commercial Flooring"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-3xl font-bold text-white mb-2">Corporate & Commercial</h3>
                <p className="text-white/90 mb-4">Premium carpet solutions for professional environments</p>
                <a href="#contact" className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#FF6B35]/80 transition-colors">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="relative group overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="aspect-[16/9]">
                <img 
                  src="https://readdy.ai/api/search-image?query=luxury%20vinyl%20plank%20flooring%20installation%20in%20modern%20interior%20space%20realistic%20wood%20texture%20LVP%20laminate%20contemporary%20design%20clean%20aesthetic%20residential%20commercial%20setting%20neutral%20tones%20high-quality%20finish%20architectural%20detail&width=1000&height=563&seq=service-lvp-laminate&orientation=landscape" 
                  alt="Luxury Vinyl & Laminates"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#2E5C8A]/80 to-[#2E5C8A]/40"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">Luxury Vinyl & Laminates</h3>
                  <p className="text-white/90 text-sm mb-3">Durable, stylish LVP solutions for any space</p>
                  <a href="#contact" className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#FF6B35]/80 transition-colors">
                    Learn More <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="relative group overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="aspect-[16/9]">
                <img 
                  src="https://readdy.ai/api/search-image?query=premium%20hardwood%20flooring%20installation%20natural%20wood%20grain%20texture%20elegant%20interior%20design%20luxury%20residential%20space%20warm%20tones%20sophisticated%20craftsmanship%20high-end%20finish%20architectural%20photography%20classic%20aesthetic%20refined%20atmosphere&width=1000&height=563&seq=service-hardwood-specialty&orientation=landscape" 
                  alt="Hardwood & Specialty Surfaces"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-amber-900/70 to-amber-900/30"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">Hardwood & Specialty Surfaces</h3>
                  <p className="text-white/90 text-sm mb-3">Timeless elegance with expert installation</p>
                  <a href="#contact" className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#FF6B35]/80 transition-colors">
                    Learn More <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-product-shop>
            <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
              <i className="ri-building-line text-3xl text-[#FF6B35]"></i>
            </div>
            <h4 className="font-semibold text-gray-800 mb-1">Corporate</h4>
            <p className="text-sm text-gray-600">Office spaces</p>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-product-shop>
            <div className="w-16 h-16 flex items-center justify-center bg-[#2E5C8A]/10 rounded-full mx-auto mb-4">
              <i className="ri-store-line text-3xl text-[#2E5C8A]"></i>
            </div>
            <h4 className="font-semibold text-gray-800 mb-1">Retail</h4>
            <p className="text-sm text-gray-600">Commercial stores</p>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-product-shop>
            <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
              <i className="ri-hospital-line text-3xl text-[#FF6B35]"></i>
            </div>
            <h4 className="font-semibold text-gray-800 mb-1">Healthcare</h4>
            <p className="text-sm text-gray-600">Medical facilities</p>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-product-shop>
            <div className="w-16 h-16 flex items-center justify-center bg-[#2E5C8A]/10 rounded-full mx-auto mb-4">
              <i className="ri-home-smile-line text-3xl text-[#2E5C8A]"></i>
            </div>
            <h4 className="font-semibold text-gray-800 mb-1">Residential</h4>
            <p className="text-sm text-gray-600">Luxury homes</p>
          </div>
        </div>
      </div>
    </section>
  );
}
